var exports = {
  "nd": "TableGamePanel.module__panel___RFBhUE",
  "tp": "TableGamePanel.module__table___RFBhUE",
  "wx": "TableGamePanel.module__header___RFBhUE",
  "DD": "TableGamePanel.module__title___RFBhUE",
  "aX": "TableGamePanel.module__back___RFBhUE",
  "xq": "TableGamePanel.module__slotList___RFBhUE",
  "V9": "TableGamePanel.module__slotRow___RFBhUE",
  "M8": "TableGamePanel.module__slotName___RFBhUE",
  "pZ": "TableGamePanel.module__slotGame___RFBhUE",
  "gi": "TableGamePanel.module__slotState___RFBhUE",
};

module.exports = exports;
